import React from 'react';
import { PageHeader } from '../components/Layout';
import { GlassCard } from '../components/ui';
import { Target, Eye, Award } from 'lucide-react';
export const AboutPage = () => {
  return <div className="min-h-screen bg-[#050810]" data-id="element-174">
      <PageHeader title="About KDX" description="Building the future of digital commerce" data-id="element-175" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-176">
        <div className="space-y-12" data-id="element-177">
          <section data-id="element-178">
            <GlassCard className="p-8 md:p-12" data-id="element-179">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-180">Who We Are</h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-181">
                KDX is a digital commerce platform focused on fast, secure, and
                reliable transactions across gaming, utilities, and digital
                services.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-182">
                We provide a seamless experience for users to access game
                top-ups, gift cards, airtime, data, utility payments, and
                marketplace transactions all in one secure platform.
              </p>
            </GlassCard>
          </section>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-183">
            <GlassCard className="p-8" data-id="element-184">
              <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center mb-6" data-id="element-185">
                <Target className="w-6 h-6 text-purple-400" data-id="element-186" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-187">Mission</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-188">
                To simplify access to digital payments and gaming services,
                making transactions fast, secure, and accessible to everyone.
              </p>
            </GlassCard>

            <GlassCard className="p-8" data-id="element-189">
              <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-6" data-id="element-190">
                <Eye className="w-6 h-6 text-blue-400" data-id="element-191" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-192">Vision</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-193">
                To build a trusted platform for digital commerce across emerging
                markets, empowering users with seamless payment solutions.
              </p>
            </GlassCard>
          </div>

          <GlassCard className="p-8 md:p-12" data-id="element-194">
            <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center mb-6" data-id="element-195">
              <Award className="w-6 h-6 text-green-400" data-id="element-196" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-197">
              Our Commitment
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-198">
              We are committed to providing a secure, reliable, and
              user-friendly platform that meets the highest standards of
              compliance and customer service. Our platform is built with
              industry-leading security measures and partnerships with trusted
              payment processors to ensure your transactions are safe and
              protected.
            </p>
          </GlassCard>
        </div>
      </div>
    </div>;
};